/** Grass tufts (the stylized look): on grass, and half as many around a sapling or tree, scattered by the tile's own hash and each a little lighter or darker. */
import { KIND, type Kind } from '@bramvasterd/terrella-rules';
import * as THREE from 'three';

import { hash2 } from '@core/math';

import type { Instances } from './instances';

/** How far from a tile's middle tufts grow: inside its flat top. */
export const TUFT_REACH = 0.42;

const _tint = new THREE.Color();

/** How many tufts a tile of `kind` gets when a grass tile gets `perTile`. */
export function tuftsOn(kind: Kind, perTile: number): number {
  if (kind === KIND.GRASS) return perTile;
  if (kind === KIND.SAPLING || kind === KIND.TREE) return Math.round(perTile / 2);
  return 0;
}

/** Places tile `i`'s tufts at unit direction `c`, `grow` times their own size; returns how many. */
export function placeTufts(
  ins: Instances,
  i: number,
  c: THREE.Vector3,
  kind: Kind,
  perTile: number,
  grow = 1,
): number {
  const count = tuftsOn(kind, perTile);
  // a sapling or tree stands in the middle: its tufts keep out of the trunk's way
  const inner = kind === KIND.GRASS ? 0.04 : 0.16;
  for (let k = 0; k < count; k++) {
    const angle = hash2(i, 200 + k) * Math.PI * 2;
    const r = inner + (TUFT_REACH - inner) * Math.sqrt(hash2(i, 300 + k));
    const shade = 0.88 + 0.24 * hash2(i, 400 + k);
    _tint.setRGB(shade, shade, shade * 0.96);
    const yaw = hash2(i, 500 + k) * Math.PI * 2;
    const scale = (0.75 + 0.5 * hash2(i, 600 + k)) * grow;
    ins.put('tuft', c, Math.cos(angle) * r, Math.sin(angle) * r, yaw, scale, _tint);
  }
  return count;
}
